import WebsiteModal from "modal/WebsiteModal";

export default class TestimonialModal extends WebsiteModal {
    constructor(clonedElement) {
        super();
        this.$clonedElement = $(clonedElement);
        this.text = this.$clonedElement.find('.product-card__hidden-content').text();
        this.image = this.$clonedElement.find('.product-card__logo')
        this.case_study_link = this.$clonedElement.find('.btn');
        this.author_name = this.$clonedElement.attr('data-author-name');
        this.author_company = this.$clonedElement.attr('data-author-company');
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--testimonial-card"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container modal__container--900"}, [
                    eotwJSXFactory('button', {className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "testimonial-card testimonial-card--modal"}, [
                        eotwJSXFactory('div', {className: "testimonial-card__icon icon icon--filled icon--small accent--navy"}),
                        eotwJSXFactory('p', null, [this.text]),
                        eotwJSXFactory('div', {className: "testimonial-card__footer"}, [
                            eotwJSXFactory('div', {className: "testimonial-card__author"}, [
                                eotwJSXFactory('p', null, [this.author_name]),
                                eotwJSXFactory('p', null, [this.author_company]),
                                this.case_study_link
                            ]),
                            eotwJSXFactory('div', {className: "testimonial-card__logo"}, [
                                this.image
                            ])
                        ])
                    ])
                ])
            ])
        );
    }
}
